import { Toast } from "primereact/toast";
import { useRef } from "react";
import { InvoiceIncentiveTable } from "./Table";
import { IPermissionProps } from "../../models/Login";

interface IProps {
    permissions: IPermissionProps;
}

export const CalculatedInvoiceIncentive = (props: IProps) => {
    const toast = useRef<any>(null);
    return (
        <>
            <InvoiceIncentiveTable permissions={props.permissions} toast={toast} />
            <Toast ref={toast} />
        </>
    );
}